import { useTranslation } from 'react-i18next';
import { testimonials } from '@/mocks/testimonials';

export default function Testimonials() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-accent-400"></span>
            <span className="text-xs text-foreground-400 font-label font-medium uppercase tracking-wider">
              {t('testimonialsTag')}
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-900 font-semibold leading-tight mb-3">
            {t('testimonialsTitle')}
            <br />
            {t('testimonialsSubtitle')}
          </h2>
          <p className="text-sm text-foreground-500 font-body max-w-lg mx-auto">
            Реальные отзывы от пользователей YOYBUY Sheet со всего мира
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: item.stars }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-sm"></i>
                  </span>
                ))}
              </div>

              <h4 className="font-label font-semibold text-foreground-900 text-sm mb-2">
                {item.title}
              </h4>

              <p className="text-sm text-foreground-600 font-body leading-relaxed flex-1 mb-4">
                {item.text}
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-background-200/60">
                <img
                  src={item.avatar}
                  alt={item.name}
                  title={item.name}
                  className="w-10 h-10 rounded-full object-cover shrink-0"
                />
                <div>
                  <p className="text-sm font-label font-semibold text-foreground-900">
                    {item.name}
                  </p>
                  <p className="text-xs text-foreground-500 font-body">
                    {item.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}